// extracted by mini-css-extract-plugin
export var description = "styles-module--description--8c7f9";
export var title = "styles-module--title--89cd1";